import { useMatchRoute, useNavigate } from '@tanstack/react-router';
import { type ReactNode, useState } from 'react';
import { useSession } from '../../../lib/authClient.js';
import { useWorkflowCatalog, useWorkflowDetails } from '../../../lib/workflows.hooks.js';
import { AlisonRunProvider } from './AlisonRunProvider.js';
import { displaysOf } from './data/alisonRun.js';
import { useAlisonLiveRun } from './data/useAlisonLiveRun.js';

export function AlisonRunData({ children }: { children: ReactNode }): ReactNode {
  const { data: session } = useSession();
  const navigate = useNavigate();
  const matchRoute = useMatchRoute();
  const [actions, setActions] = useState<string[]>([]);
  const [active, setActive] = useState(false);
  const catalog = useWorkflowCatalog([], active && session !== null && session !== undefined);
  const cards = catalog.data?.chainSteps ?? [];
  const details = useWorkflowDetails(actions);
  const displays = displaysOf(cards, details);
  const copy = catalog.data?.alisonRunCopy ?? null;
  const live = useAlisonLiveRun(cards, details, displays, copy);
  return (
    <AlisonRunProvider
      details={details}
      cards={cards}
      displays={displays}
      copy={copy}
      live={live}
      onPathActions={setActions}
      onActiveChange={setActive}
      onOpenResults={(workflowId, search, runId) => {
        const run = runId ?? undefined;
        // Already on the page: keep what changed there since the run began.
        const onPage =
          matchRoute({ to: '/workflows/$workflowId', params: { workflowId } }) !== false;
        void navigate({
          to: '/workflows/$workflowId',
          params: { workflowId },
          search: onPage ? (previous) => ({ ...previous, run }) : { ...search, run },
          replace: onPage,
        });
      }}
    >
      {children}
    </AlisonRunProvider>
  );
}
